(function () {

function init(root) {
  function q(s) { return root.querySelector(s); }
  var ds = root.dataset;

  /* theme toggle, remembered per browser */
  try { var saved = localStorage.getItem("toytopia-theme"); if (saved) root.setAttribute("data-theme", saved); } catch (e) {}
  q(".theme").addEventListener("click", function () {
    var next = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
    root.setAttribute("data-theme", next);
    try { localStorage.setItem("toytopia-theme", next); } catch (e) {}
  });

  /* countdown, South Africa time */
  var startAt = Date.parse(ds.start), endAt = Date.parse(ds.end);
  function pad(n) { return String(n).padStart(2, "0"); }
  var lastSec = null;
  function tick() {
    var now = Date.now(), label, left;
    if (!isNaN(startAt) && now < startAt) { label = "Deals start in"; left = startAt - now; }
    else if (!isNaN(endAt) && now < endAt) { label = "Deals end in"; left = endAt - now; }
    else { label = "The deals have ended"; left = 0; }
    q(".tagline").textContent = label;
    q(".cd-d").textContent = Math.floor(left / 864e5);
    q(".cd-h").textContent = pad(Math.floor(left / 36e5) % 24);
    q(".cd-m").textContent = pad(Math.floor(left / 6e4) % 60);
    var sec = pad(Math.floor(left / 1e3) % 60), sEl = q(".cd-s");
    sEl.textContent = sec;
    if (lastSec !== null && lastSec !== sec) { sEl.classList.remove("bump"); void sEl.offsetWidth; sEl.classList.add("bump"); }
    lastSec = sec;
  }
  tick(); setInterval(tick, 1000);

  /* scrolling deals ribbon */
  var half = "", label = ds.label || "Black Friday deals";
  for (var r = 0; r < 6; r++) half += "<span>Black Friday deals</span><span>" + label.replace(/[<>&]/g, "") + "</span>";
  q(".track").innerHTML = half + half;

  /* toy drawings, inline SVG so no outside images are needed */
  function art(kind, c1, c2) {
    var s = {
      blocks: '<rect x="8" y="58" width="40" height="40" rx="7" fill="' + c1 + '"/><rect x="52" y="58" width="40" height="40" rx="7" fill="' + c2 + '"/><rect x="28" y="14" width="40" height="40" rx="7" fill="#fffdf7" transform="rotate(-6 48 34)"/>',
      bear: '<circle cx="27" cy="28" r="15" fill="' + c1 + '"/><circle cx="73" cy="28" r="15" fill="' + c1 + '"/><circle cx="50" cy="56" r="34" fill="' + c1 + '"/><circle cx="50" cy="67" r="14" fill="' + c2 + '"/><circle cx="39" cy="50" r="3.5" fill="#1c1738"/><circle cx="61" cy="50" r="3.5" fill="#1c1738"/>',
      rocket: '<path d="M50 6c18 14 22 40 14 62H36C28 46 32 20 50 6z" fill="' + c1 + '"/><circle cx="50" cy="38" r="9" fill="#fffdf7"/><path d="M36 56L18 76l20-6zM64 56l18 20-20-6z" fill="' + c2 + '"/><path d="M42 72h16l-8 22z" fill="#fffdf7"/>',
      car: '<path d="M8 66l10-24c2-5 6-8 11-8h42c5 0 9 3 11 8l10 24z" fill="' + c1 + '"/><rect x="4" y="62" width="92" height="20" rx="8" fill="' + c2 + '"/><circle cx="28" cy="82" r="11" fill="#1c1738"/><circle cx="72" cy="82" r="11" fill="#1c1738"/><circle cx="28" cy="82" r="3.5" fill="#fffdf7" stroke-width="0"/><circle cx="72" cy="82" r="3.5" fill="#fffdf7" stroke-width="0"/>',
      puzzle: '<rect x="14" y="22" width="72" height="62" rx="10" fill="' + c1 + '"/><circle cx="50" cy="20" r="11" fill="' + c1 + '"/><circle cx="88" cy="53" r="11" fill="' + c2 + '"/><rect x="26" y="34" width="22" height="22" rx="5" fill="' + c2 + '"/><rect x="52" y="52" width="22" height="22" rx="5" fill="#fffdf7"/>',
      doll: '<circle cx="50" cy="22" r="16" fill="#fffdf7"/><path d="M34 40h32l12 52H22z" fill="' + c1 + '"/><path d="M30 20c0-16 40-16 40 0-8-6-32-6-40 0z" fill="' + c2 + '"/>',
      robot: '<rect x="22" y="26" width="56" height="44" rx="12" fill="' + c1 + '"/><rect x="34" y="82" width="32" height="14" rx="5" fill="' + c2 + '"/><circle cx="38" cy="46" r="7" fill="#fffdf7"/><circle cx="62" cy="46" r="7" fill="#fffdf7"/><circle cx="38" cy="46" r="2.5" fill="#1c1738" stroke-width="0"/><circle cx="62" cy="46" r="2.5" fill="#1c1738" stroke-width="0"/><path d="M50 26V12" fill="none"/><circle cx="50" cy="10" r="6" fill="' + c2 + '"/>'
    }[kind] || "";
    return '<svg viewBox="0 0 100 100" aria-hidden="true">' + s + '</svg>';
  }

  var pile = root.querySelectorAll(".pile .sticker");
  pile[0].innerHTML = art("rocket", "#fffdf7", "#ffc928");
  pile[1].innerHTML = art("bear", "#e0a56d", "#fff1cf");
  pile[2].innerHTML = art("blocks", "#ff6b95", "#ffc928");

  /* confetti drifting behind the hero */
  var conf = document.createElement("div");
  conf.className = "confetti"; conf.setAttribute("aria-hidden", "true");
  var cols = ["#ff6b95", "#ffc928", "#4fe3b9", "#9a87ff"], shapes = ["50%", "4px", "0"];
  for (var k = 0; k < 16; k++) {
    var b = document.createElement("span"), sz = 8 + Math.random() * 14, sh = k % 3;
    b.className = "bit";
    b.style.cssText = "left:" + (Math.random() * 96) + "%;top:" + (Math.random() * 90) + "%;width:" + sz + "px;height:" + sz + "px;background:" + cols[k % 4] + ";border-radius:" + shapes[sh] + ";--dx:" + (Math.random() * 60 - 30).toFixed(0) + "px;--dy:" + (Math.random() * 60 - 30).toFixed(0) + "px;--t:" + (7 + Math.random() * 7).toFixed(1) + "s;--d:-" + (Math.random() * 8).toFixed(1) + "s;" + (sh === 2 ? "clip-path:polygon(50% 0,100% 100%,0 100%);" : "");
    conf.appendChild(b);
  }
  q(".hero").prepend(conf);

  /* ways to play */
  var cats = [
    ["Build and stack", "Blocks, bricks and big ideas", "blocks", "#ff6b95", "#4fe3b9"],
    ["Cuddle and care", "Plush friends and doll play", "bear", "#e0a56d", "#ff6b95"],
    ["Zoom and race", "Cars, rockets and things that go", "rocket", "#4fe3b9", "#ffc928"],
    ["Think and solve", "Puzzles, robots and STEM kits", "puzzle", "#9a87ff", "#ffc928"]
  ];
  var shop = ds.shop || "/collections/all";
  q(".cats").innerHTML = cats.map(function (c) {
    return '<a class="cat" href="' + shop + '">' + art(c[2], c[3], c[4]) + "<h3>" + c[0] + "</h3><span>" + c[1] + "</span></a>";
  }).join("");

  /* product tiles: tint every tile, and draw a toy where a product has no photo */
  var kinds = ["blocks", "bear", "rocket", "car", "puzzle", "doll", "robot"];
  var tints = [["#ff6b95", "#4fe3b9", "#ffe3a3"], ["#ffc928", "#ff6b95", "#bfe8ff"], ["#4fe3b9", "#9a87ff", "#ffc9d9"], ["#9a87ff", "#ffc928", "#c9f3df"]];
  Array.prototype.forEach.call(root.querySelectorAll(".grid .art"), function (el) {
    var i = parseInt(el.getAttribute("data-i"), 10) || 0, t = tints[i % 4];
    el.style.background = t[2];
    if (!el.querySelector("img")) el.insertAdjacentHTML("afterbegin", art(kinds[i % 7], t[0], t[1]));
  });

  /* in the theme editor only: show example toys on an empty shelf so the layout can be judged */
  if (ds.design === "true" && !q(".grid .card")) {
    var ex = [["Rainbow Stack Blocks", "Building", 0], ["Cloud Cuddle Bear", "Plush", 1], ["Star Chaser Rocket Set", "Playset", 2], ["Turbo Racer Pull-back Car", "Vehicles", 3]];
    q(".grid").innerHTML = ex.map(function (e, i) {
      var t = tints[i % 4];
      return '<article class="card"><div class="art" style="background:' + t[2] + '"><span class="badge">example</span>' + art(kinds[(i * 2) % 7], t[0], t[1]) + '</div><div class="info"><small>' + e[1] + "</small><h3>" + e[0] + '</h3><div class="row"><span class="price">R---</span></div></div></article>';
    }).join("");
  }
}

function boot() {
  Array.prototype.forEach.call(document.querySelectorAll(".tt"), function (r) {
    if (r.getAttribute("data-tt-ready")) return;
    r.setAttribute("data-tt-ready", "1");
    init(r);
  });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
document.addEventListener("shopify:section:load", boot);
})();